import { getUserAccounts } from '../api/user.service.js'

let userAccountsCache = null

export const getUserAccountsSingleton = async () => {
  if (userAccountsCache) {
    return userAccountsCache
  }
  userAccountsCache = await getUserAccounts()
  return userAccountsCache
}
